import React, { useEffect } from "react";
import AnimateCC from "../../../animate";
import { RocketMenu } from "../RocketMenu";
import { SpaceGame } from "./SpaceGame";
import additionalSounds from "./SpaceSounds";

const SpaceComponent: React.FC<{
    frame: RocketMenu;
}> = ({ frame }) => {
    const game = React.useRef(new SpaceGame(frame));
    useEffect(() => {
        const game_instance = game.current;
        return () => {
            game_instance.unload();
        };
    }, []);
    return (
        <AnimateCC
            base="/lunapark/rocket/space"
            animationName="space"
            scale={0.75}
            shiftX={140}
            shiftY={5}
            additionalSounds={additionalSounds}
            onLoaded={game.current.loaded}
        />
    );
};
export default SpaceComponent;
